import { useState, useEffect } from 'react';

export const isPrintJobEnabled = () => {
    const setting = localStorage.getItem('enable_print_jobs');
    return setting === 'true';
};

export const updatePrintJobSetting = (enabled) => {
    localStorage.setItem('enable_print_jobs', enabled ? 'true' : 'false');
    window.dispatchEvent(new Event('print_job_setting_changed'));
    window.dispatchEvent(new Event('storage'));
};

export const usePrintJobSetting = () => {
    const [enablePrintJobs, setEnablePrintJobs] = useState(isPrintJobEnabled());

    useEffect(() => {
        const handleSettingChange = () => {
            setEnablePrintJobs(isPrintJobEnabled());
        };

        window.addEventListener('print_job_setting_changed', handleSettingChange);
        window.addEventListener('storage', handleSettingChange);

        return () => {
            window.removeEventListener('print_job_setting_changed', handleSettingChange);
            window.removeEventListener('storage', handleSettingChange);
        };
    }, []);

    const handleUpdate = (enabled) => {
        updatePrintJobSetting(enabled);
        setEnablePrintJobs(enabled);
    };

    return { enablePrintJobs, updatePrintJobSetting: handleUpdate };
};
